import { pxToRem, theme } from '@noths/polaris-client-styles';
import { css } from 'styled-components';

const { spacing, fonts, colors } = theme;

export const wrapper = css`
  background-color: ${colors.blueAlice};
  display: flex;
  flex-direction: column;
  height: 100%;
  align-items: center;
  justify-content: center;
`;

export const spinner = css`
  width: ${pxToRem(spacing.xxl)};
  height: ${pxToRem(spacing.xxl)};
`;

export const copy = css`
  font-weight: ${fonts.PRIMARY_SEMIBOLD.weight};
  margin-top: ${pxToRem(spacing.sm)};
`;
